var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2370_1757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9589 4.8001L8.80395 11.9551C8.09145 12.6676 5.97643 12.9976 5.50393 12.5251C5.03143 12.0526 5.35393 9.93756 6.06643 9.22506L13.2289 2.06258C13.4056 1.86987 13.6194 1.71497 13.8576 1.60719C14.0957 1.49942 14.3533 1.44099 14.6146 1.43549C14.8759 1.42999 15.1357 1.47749 15.3782 1.57515C15.6207 1.67281 15.8409 1.81861 16.0255 2.00371C16.21 2.18881 16.3552 2.40938 16.4522 2.65213C16.5492 2.89488 16.5961 3.15476 16.5898 3.41609C16.5836 3.67743 16.5244 3.93482 16.4161 4.17269C16.3076 4.41055 16.1521 4.62399 15.9589 4.8001Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3H4.5C3.70435 3 2.94133 3.31606 2.37872 3.87868C1.81612 4.44129 1.5 5.20435 1.5 6V13.5C1.5 14.2957 1.81612 15.0587 2.37872 15.6213C2.94133 16.1839 3.70435 16.5 4.5 16.5H12.75C14.4075 16.5 15 15.15 15 13.5V9.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2370_1757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditText);
export default __webpack_public_path__ + "static/media/edit_text.14cab8d35c4c4a92f8da4fa906d9b731.svg";
export { ForwardRef as ReactComponent };